(function (angular) {
    'use strict';

    angular.module('app')
        .controller('membersController', membersController);

    membersController.$inject = [
        'UsersApi',
        'eventsPayload',
        'promotionsPayload',
        '$location',
        'Users',
        '$scope',
        'thisUser',
    ];

    function membersController(
        UsersApi,
        eventsPayload,
        promotionsPayload,
        $location,
        Users,
        $scope,
        thisUser,
    ) {
        const vm = this;
        vm.limit = 12;
        this.$onInit = $onInit;

        // properties
        vm.isLoading = true;
        vm.defaultFilters = {
            company: '',
            custom_attrs: {},
            full_name: '',
            industry: '-- All --',
            near: '',
            near_distance: 20000,
            page: 1,
            page_size: vm.limit,
            // 'role[]': ['member', 'admin', 'super_admin'],
            'with[]': ['promotions'],
            is_active: 1,
            hide_not_in_directory: true,
            exclude_id: thisUser.id,
        };
        vm.filters = { ...vm.defaultFilters };
        vm.members = {};
        vm.events = eventsPayload;
        vm.promotions = promotionsPayload;

        // methods
        vm.sendMessage = sendMessage;
        vm.getMembers = getMembers;
        vm.resetMembers = resetMembers;
   /**
         * Opens modal to send a message to this user
         * @param  {int} userId - ID of user to send message to
         * @return {void}
         */
        function sendMessage(userId) {
            Users.sendMessage(userId);
        }
        /**
         * Initialises the controller.
         *
         * @return {void}
         */
        function $onInit() {
            const urlParams = $location.search();
            vm.filters = {
                ...vm.filters,
                ...urlParams,
            };
            vm.filters.page = parseInt(vm.filters.page, 10);
            vm.filters.page_size = parseInt(vm.filters.page_size, 10);
            getMembers();
        }

        /**
         * Retrieves members from the API and makes available to scope
         * @return {void}
         */
        function getMembers() {
            vm.isLoading = true;
            updateURL();

            // get members
            UsersApi.get(vm.filters, response => {
                vm.members = response;
                vm.isLoading = false;
            }, err => {
                vm.isLoading = false;
            });
        } $scope.loadMore = function() {
            var increamented = vm.limit + 12;
            vm.limit = increamented;
            vm.filters.page_size = vm.limit;
            UsersApi.get(vm.filters, response => {
                vm.members = response;
                vm.isLoading = false;
            }, err => {
                vm.isLoading = false;
            });
        };

        /**
         * Reset the members listing
         *
         * @returns void
         */
        function resetMembers() {
            vm.filters = { ...vm.defaultFilters };
            getMembers();
        }

        /**
         * Builds a new object of filters with any empty values removed.
         *
         * @returns {Record<string, any>}
         */
        function sanitizeFilters(): Record<string, any> {
            return Object.keys(vm.filters).reduce((sanitized, key) => {
                const value = vm.filters[key];

                // skip if the value is essentially empty
                if (value === null || value === '' || value === '-- All --') {
                    return sanitized;
                }

                sanitized[key] = value;

                return sanitized;
            }, {});
        }

        /**
         * Persists any active filters to the URL.
         * NOte: The URL will be kept clean if the default filters are active.
         *
         * @returns {void}
         */
        function updateURL(): void {
            let filters = sanitizeFilters();
            const filtersMatchDefaults = JSON.stringify(vm.defaultFilters) === JSON.stringify(vm.filters);

            if (filtersMatchDefaults) {
                filters = {};
            }

            $location.search(filters);
        }
    }

}(angular));
